import { Link } from "react-router-dom";
import { characters } from "@/mocks/characters";
import { works } from "@/mocks/works";
import CharacterCard from "@/components/feature/CharacterCard";
import { usePageMeta } from "@/hooks/usePageMeta";

const ranked = [...characters].sort((a, b) => b.rarity - a.rarity).slice(0, 6);
const featured = [...characters].sort(() => Math.random() - 0.5).slice(0, 6);

export default function Home() {
  usePageMeta(
    "女神漫画角色图鉴｜高人气女神角色大全·排名与介绍",
    "女神漫画角色图鉴页收录各作品中的高人气女神角色，按作品与设定分类整理成角色大全。点开即可查看每位女神漫画角色的详细背景、性格特点与名场面介绍，追漫前先做足功课。"
  );

  return (
    <>
      {/* Hero */}
      <section className="relative flex min-h-[560px] md:min-h-[620px] w-full items-center justify-center overflow-hidden bg-foreground-950">
        <img
          src="https://readdy.ai/api/search-image?query=ethereal%20celestial%20goddess%20realm%20with%20luminous%20golden%20constellations%20and%20swirling%20rose%20nebula%20above%20a%20tranquil%20starry%20dome%2C%20dreamy%20fantasy%20anime%20wide%20key%20visual%2C%20warm%20amber%20crimson%20and%20soft%20ivory%20tones%2C%20glowing%20starlight%20particles%2C%20majestic%20elegant%20atmosphere&width=1600&height=900&seq=hero-goddess-2026&orientation=landscape"
          alt="星辰与女神交织的奇幻背景"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
        <div className="relative z-10 w-full max-w-4xl px-4 text-center text-white">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-1.5 text-xs tracking-wide whitespace-nowrap">
            <i className="ri-sparkling-2-line text-accent-300" aria-hidden="true"></i>
            高人气女神角色图鉴 · 持续更新
          </span>
          <h1 className="mt-6 font-heading text-3xl font-black leading-tight md:text-5xl">
            走进女神漫画角色图鉴
            <span className="mt-2 block text-accent-300">一次认全各大作品的高人气女神</span>
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base">
            收录各作品中的高人气女神漫画角色，按作品与设定分类整理成角色大全。点开即可查看每位女神角色的详细背景、性格特点与名场面介绍，追漫之前，先做足功课。
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/characters"
              className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold whitespace-nowrap transition-colors hover:bg-primary-400 sm:w-auto"
            >
              查看角色图鉴
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
            <Link
              to="/works"
              className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/30 bg-white/10 px-7 py-3 text-sm font-semibold whitespace-nowrap backdrop-blur transition-colors hover:bg-white/20 sm:w-auto"
            >
              浏览作品谱系
            </Link>
          </div>
          <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-white/20 pt-6">
            {[
              { num: `${characters.length}+`, label: "收录角色" },
              { num: `${works.length}`, label: "作品谱系" },
              { num: "24h", label: "持续更新" },
            ].map((s) => (
              <div key={s.label}>
                <dt className="text-2xl font-bold text-accent-300 md:text-3xl">{s.num}</dt>
                <dd className="mt-1 text-xs text-white/75">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </section>

      {/* 人气排行 */}
      <section className="bg-background-50 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
            <div>
              <p className="text-sm font-medium text-primary-600">P R E S T I G E</p>
              <h2 className="mt-2 font-heading text-2xl font-bold md:text-4xl">女神人气排行榜</h2>
              <p className="mt-3 max-w-xl text-sm text-foreground-600">
                综合读者喜爱度与讨论热度整理的人气榜单，帮助你快速锁定最值得认识的女神角色。
              </p>
            </div>
            <Link
              to="/characters"
              className="inline-flex items-center gap-1.5 rounded-full border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 whitespace-nowrap transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              查看全部角色
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>

          <ol className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {ranked.map((c, i) => (
              <li key={c.id}>
                <Link
                  to={`/character/${c.id}`}
                  className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-all hover:border-accent-300 hover:bg-accent-50/40"
                >
                  <span className="font-heading text-2xl font-black text-secondary-300 group-hover:text-accent-500">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="flex h-16 w-12 shrink-0 overflow-hidden rounded-md">
                    <img src={c.image} alt={`${c.name} 立绘`} className="h-full w-full object-cover object-top" />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate font-heading text-base font-bold">{c.name}</span>
                    <span className="block truncate text-xs text-foreground-500">{c.epithet}</span>
                  </span>
                  <span className="flex items-center gap-1 text-sm font-semibold text-primary-600">
                    <i className="ri-heart-3-fill text-accent-500" aria-hidden="true"></i>
                    {c.rarity}
                  </span>
                </Link>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* 热门角色 */}
      <section className="bg-background-100 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="text-center">
            <p className="text-sm font-medium text-primary-600">F E A T U R E D</p>
            <h2 className="mt-2 font-heading text-2xl font-bold md:text-4xl">热门女神角色推荐</h2>
            <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
              每一段神格背后，都有一段动人的故事。点开卡片，认识她们的设定与名场面。
            </p>
          </div>
          <div className="mt-8 grid grid-cols-2 gap-4 md:gap-6 lg:grid-cols-3 xl:grid-cols-6">
            {featured.map((c) => (
              <CharacterCard key={c.id} c={c} />
            ))}
          </div>
        </div>
      </section>

      {/* 作品谱系 */}
      <section className="bg-background-50 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
            <div>
              <p className="text-sm font-medium text-primary-600">W O R K S</p>
              <h2 className="mt-2 font-heading text-2xl font-bold md:text-4xl">作品谱系</h2>
              <p className="mt-3 max-w-xl text-sm text-foreground-600">
                角色按所属作品分类整理，从奇幻恋爱到海洋神话，总有一部适合你的追漫清单。
              </p>
            </div>
            <Link
              to="/works"
              className="inline-flex items-center gap-1.5 rounded-full border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 whitespace-nowrap transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              进入作品库
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>

          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {works.map((w) => {
              const count = characters.filter((c) => c.workId === w.id).length;
              return (
                <Link
                  key={w.id}
                  to="/works"
                  className="group relative overflow-hidden rounded-lg"
                  aria-label={`进入作品《${w.title}》的角色列表`}
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={w.cover}
                      alt={`${w.title} 作品封面`}
                      className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-transparent"></div>
                  <div className="absolute inset-x-0 bottom-0 p-5">
                    <span className="rounded-full bg-accent-500 px-3 py-1 text-xs text-background-50">{w.category}</span>
                    <h3 className="mt-3 font-heading text-xl font-bold text-white">{w.title}</h3>
                    <p className="mt-1 text-xs text-white/80">{w.subtitle} · {count} 位女神</p>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* 图鉴指南 */}
      <section className="bg-background-100 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid items-center gap-10 lg:grid-cols-2">
            <div>
              <p className="text-sm font-medium text-primary-600">G U I D E</p>
              <h2 className="mt-2 font-heading text-2xl font-bold md:text-4xl">追漫之前，先看懂女神设定</h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                每个角色档案都从作品背景、身份设定、性格特点到名场面做了系统整理。无论你是刚入坑的新人，还是想补全设定细节的老读者，都能在这里快速建立对女神角色谱系的完整认知。
              </p>
              <ul className="mt-6 grid gap-3 sm:grid-cols-2">
                {[
                  { icon: "ri-focus-3-line", t: "身份设定", d: "种族、称号与所属神系一目了然" },
                  { icon: "ri-heart-pulse-line", t: "性格解析", d: "拆解角色行为背后的动机" },
                  { icon: "ri-movie-2-line", t: "名场面", d: "还原最令人难忘的剧情高光" },
                  { icon: "ri-route-line", t: "相关推荐", d: "同作品女神角色相互串联" },
                ].map((f) => (
                  <li key={f.t} className="flex gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-500/10 text-primary-600">
                      <i className={`${f.icon} text-lg`} aria-hidden="true"></i>
                    </span>
                    <span>
                      <span className="block font-semibold text-foreground-900">{f.t}</span>
                      <span className="mt-1 block text-xs text-foreground-600">{f.d}</span>
                    </span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20moon%20goddess%20in%20flowing%20pale%20jade%20kimono%20under%20a%20full%20moon%20holding%20a%20small%20lantern%2C%20wafu%20fantasy%20anime%20portrait%2C%20soft%20ivory%20silver%20and%20muted%20vermilion%2C%20serene%20tranquil%20atmosphere&width=700&height=900&seq=home-col-1&orientation=portrait"
                alt="月下女神角色插画"
                className="mt-8 h-full w-full rounded-lg object-cover object-top"
              />
              <img
                src="https://readdy.ai/api/search-image?query=ethereal%20star%20goddess%20with%20silver%20hair%20and%20golden%20constellation%20ornaments%20reaching%20toward%20glowing%20stars%2C%20fantasy%20anime%20portrait%2C%20warm%20gold%20and%20rose%20accents%2C%20luminous%20magical%20atmosphere&width=700&height=900&seq=home-col-2&orientation=portrait"
                alt="织星女神角色插画"
                className="h-full w-full rounded-lg object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-background-50 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="relative overflow-hidden rounded-2xl bg-primary-700 px-6 py-12 text-center md:px-12 md:py-16">
            <div className="absolute inset-0 bg-gradient-to-r from-primary-700 via-primary-600 to-accent-600 opacity-90"></div>
            <div className="relative z-10 mx-auto max-w-2xl text-white">
              <h2 className="font-heading text-2xl font-bold md:text-4xl">准备好认识下一位女神了吗？</h2>
              <p className="mt-4 text-sm leading-relaxed text-white/85 md:text-base">
                打开角色图鉴，按作品或设定筛选你感兴趣的女神，深入了解她们的背景与名场面。
              </p>
              <Link
                to="/characters"
                className="mt-7 inline-flex items-center gap-2 rounded-full bg-background-50 px-7 py-3 text-sm font-semibold text-primary-700 whitespace-nowrap transition-transform hover:-translate-y-0.5"
              >
                开始浏览图鉴
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}